export default __webpack_public_path__ + "static/media/over-view.1da292be.png";